import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import type { TabTitle } from 'state/workspaces/tabs/tabs.selector';

export function useLocalizedTabName(title: TabTitle | undefined): string | undefined {
  const { formatMessage } = useIntl();

  return useMemo(() => {
    if (title?.customizedName === undefined && title?.tabIndex === undefined) {
      return undefined;
    }

    if (title?.customizedName !== undefined) {
      return title?.customizedName;
    }
    switch (title?.workspaceType) {
      case 'newBatch':
        return formatMessage({ id: 'form.BatchTabDefaultName' }, { tabIndex: title?.tabIndex });
      default:
        return formatMessage({ id: 'form.QuoteTabDefaultName' }, { tabIndex: title?.tabIndex });
    }
  }, [formatMessage, title?.customizedName, title?.tabIndex, title?.workspaceType]);
}
